import styled from 'styled-components';

const PopupDiv = styled.div`
  width: 293px;
  padding: 10px;
  user-select: none;
`;

const ItemDiv = styled.div`
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  user-select: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 10px;
  transition: all 0.1s ease;

  &:hover {
    background-color: var(--color-bg-tertiary);
  }
`;

const ItemProductDiv = styled(ItemDiv)`
  height: 42px;
`;

const ItemViewAllDiv = styled(ItemDiv)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  svg {
    display: inline-block;
    opacity: 0;
    transform: translateX(-2px);
    transition:
      opacity 150ms ease,
      transform 150ms ease;
  }

  &:hover svg {
    opacity: 1;
    transform: translateX(2px);
  }
`;

const Divider = styled.div`
  height: 1px;
  background: var(--color-border-secondary);
  margin: 8px 8px 6px 8px;
`;

const NavMenuPopup = {
  PopupDiv,
  ItemDiv,
  ItemProductDiv,
  ItemViewAllDiv,
  Divider,
};

export default NavMenuPopup;
